import axios from 'axios'

export default {
    namespaced: true,
    state: {
        states: [],
        status_array: [],
        job_status_array: [],
        roles: [],
        counties: [],
        countiess: [],
        sizes: [],
        options: [],
		preffered_time: [],
		preffered_contact: [],
        how_did_hear: [],
        estimators: [],
        schedules_array: [],
        confirmations_array: [],
        assign_array: [],
        users: [],
        job_types: [],
        shapes: [],
        liner_color: [],
        priorities: [],
        amount_types: [],
        change_types: [],
        jobs: [],
        workorders: [],
        customers: [],
        leads: [],
        wousers: [],
        types: [],
        wo_types: [],
        payment_status: []
    },
    getters: {
        jobs (state) {
            return state.jobs
        },
        workorders (state) {
            return state.workorders
        },
        customers (state) {
            return state.customers
        },
        leads (state) {
            return state.leads
        },
        states (state) {
            return state.states
        },
        amountTypes (state) {
            return state.amount_types
        },
        changeTypes (state) {
            return state.change_types
        },
        statusArray (state) {
            return state.status_array
        },
        jobStatusArray (state) {
            return state.job_status_array
        },
        roles (state) {
            return state.roles
        },
        counties (state) {
            return state.counties
        },
        countiess (state) {
            return state.counties
        },
        sizes (state) {
            state.sizes.push({id: 999, price: '' , title: 'Other'})
            return state.sizes
        },
        shapes (state) {
            return state.shapes
        },
        types (state) {
            return state.types
        },
        options (state) {
            return state.options
        },
        filteredOptions (state) {
            return state.options.filter(option => {
                return option.required != "Yes"
            })
        },
        requiredOptions (state) {
            return state.options.filter(option => {
                return option.required == "Yes"
            })
        },
        requiredTotal (state) {
            var sum = 0
            state.options.forEach(option => {
                if(option.required == 'Yes')
                    sum += parseFloat(option.price)
            });
            return sum
        },
		preffered_time (state) {
			return state.preffered_time
		},
		preffered_contact (state) {
			return state.preffered_contact
		},
		how_did_hear (state) {
			return state.how_did_hear
        },
        estimators (state) {
            return state.estimators
        },
        schedulesArray (state) {
            return state.schedules_array
        },
        confirmationsArray (state) {
            return state.confirmations_array
        },
        assignArray (state) {
            return state.assign_array
        },
        users (state) {
            return state.users
        },
        job_types (state) {
            return state.job_types
        },
        liner_color (state) {
            return state.liner_color
        },
        priorities (state) {
            return state.priorities
        },
        wousers (state) {
            return state.wousers
        },
        wo_types (state) {
            return state.wo_types
        },
        payment_status (state) {
            return state.payment_status
        }
    },
    mutations: {
        SET_JOBS(state, payload) {
            state.jobs = payload
        },
        SET_WORKORDERS(state, payload) {
            state.workorders = payload
        },
        SET_CUSTOMERS(state, payload) {
            state.customers = payload
        },
        SET_LEADS(state, payload) {
            state.leads = payload
        },       
        SET_STATES(state, payload) {
            state.states = payload
        },
        SET_AMOUNT_TYPES(state, payload) {
            return state.amount_types = payload
        },
        SET_CHANGE_TYPES(state, payload) {
            return state.change_types = payload
        },
        SET_STATUS_ARR(state, payload) {
            return state.status_array = payload
        },
        SET_JOB_STATUS_ARR(state, payload) {
            return state.job_status_array = payload
        },
        SET_ROLES(state, payload) {
            return state.roles = payload
        },
        SET_COUNTIES(state, payload) {
            state.counties = payload
        },
        SET_COUNTIESS(state, payload) {
            state.countiess = payload
        },
        SET_SIZES(state, payload) {
            state.sizes = payload
        },
        SET_SHAPES(state, payload) {
            state.shapes = payload
        },
        SET_TYPES(state, payload) {
            state.types = payload
        },
        SET_OPTIONS(state, payload) {
            state.options = payload
        },
        SET_PREFFRED(state, payload) {
            return state.preffered_time = payload
		},
        SET_PREFFRED_CONTACT(state, payload) {
            return state.preffered_contact = payload
		},
        SET_HOW(state, payload) {
            return state.how_did_hear = payload
        },
        SET_ESTIMATORS(state, payload) {
            return state.estimators = payload
        },
        SET_SCHEDULES_ARR(state, payload) {
            return state.schedules_array = payload
        },
        SET_CONFIRMATION_ARR(state, payload) {
            return state.confirmations_array = payload
        },
        SET_ASSIGN_ARR(state, payload) {
            return state.assign_array = payload
        },
        SET_USERS(state, payload) {
            return state.users = payload
        },
        SET_JOB_TYPES(state, payload) {
            return state.job_types = payload
        },
        SET_JOB_TYPE(state, payload) {
            return state.job_types.push(payload)
        },
        SET_LINER_COLOR(state, payload) {
            return state.liner_color = payload
        },
        SET_PRIORITIES(state, payload) {
            return state.priorities = payload
        },
        SET_WOUSERS(state, payload) {
            return state.wousers = payload
        },
        SET_WO_TYPES(state, payload) {
            return state.wo_types = payload
        },
        SET_PAYMENT_STATUS(state, payload) {
            return state.payment_status = payload
        }
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.post('crm/data')
            commit('SET_STATES', response.data.data.states)     
            commit('SET_AMOUNT_TYPES', response.data.data.amount_types)
            commit('SET_CHANGE_TYPES', response.data.data.change_types)
            commit('SET_STATUS_ARR', response.data.data.status_array)
            commit('SET_JOB_STATUS_ARR', response.data.data.job_status_array)
            commit('SET_ROLES', response.data.data.roles)
            commit('SET_NEW_COUNT', response.data.data.new_count)
            commit('SET_ALL_COUNT', response.data.data.total_count)
            commit('SET_COUNTIES', response.data.data.counties)
            commit('SET_COUNTIESS', response.data.data.countiess)
            commit('SET_SIZES', response.data.data.sizes)
            commit('SET_SHAPES', response.data.data.shapes)
            commit('SET_TYPES', response.data.data.types)
            commit('SET_OPTIONS', response.data.data.options)
            commit('SET_PREFFRED', response.data.data.preffered_time)
            commit('SET_PREFFRED_CONTACT', response.data.data.preffered_contact)
            commit('SET_HOW', response.data.data.how_did_hear)
            commit('SET_ESTIMATORS', response.data.data.estimators)        
            commit('SET_SCHEDULES_ARR', response.data.data.schedules_array)
            commit('SET_CONFIRMATION_ARR', response.data.data.confirmations_array)
            commit('SET_ASSIGN_ARR', response.data.data.assign_array)
            commit('SET_USERS', response.data.data.users)
            commit('SET_JOB_TYPES', response.data.data.job_types)
            commit('SET_LINER_COLOR', response.data.data.liner_color)
            commit('SET_PRIORITIES', response.data.data.priorities)
            commit('SET_WOUSERS', response.data.data.wousers)
            commit('SET_WO_TYPES', response.data.data.wo_types)
            commit('SET_PAYMENT_STATUS', response.data.data.payment_status)
        },
        async addCustomer( { dispatch }, data) {
            let response = await axios.post('crm/customer/add', data)
            await dispatch('getData')
            return response.data
        },
        async updateCustomer( { dispatch }, data) {
            let response = await axios.post('crm/customer/update', data)
            await dispatch('getData')
            return response.data
        },
        async addComment(_, data) {
            let response = await axios.post('crm/lead/comment', data)        
            return response.data
        },
        async newEmail(_, data) {
            let response = await axios.post('crm/lead/email', data)        
            return response.data
        },
        async newSms(_, data) {
            let response = await axios.post('crm/sms', data)        
            return response.data
        },
        async addUser( { dispatch }, data) {
            let response = await axios.post('crm/user/add', data)
            await dispatch('getData')
            return response.data
        },
        async updateUser( { dispatch }, data) {
            let response = await axios.post('crm/user/update', data)
            await dispatch('getData')
            return response.data
        },
        async addLead( { dispatch }, data) {
            let response = await axios.post('crm/lead/add', data)
            await dispatch('getData')
            return response.data
        },
        async updateLead( { dispatch }, data) {
            let response = await axios.post('crm/lead/update', data)
            await dispatch('getData')
            return response.data
        },    
        async addJob( { dispatch }, data) {
            let response = await axios.post('crm/job/add', data)
            await dispatch('getData')
            return response.data
        },
        async updateJob( { dispatch }, data) {
            let response = await axios.post('crm/job/update', data)
            await dispatch('getData')
            return response.data
        },
        async updateDeposit( { dispatch }, data) {
            let response = await axios.post('crm/job/deposit/update', data)
            await dispatch('getData')
            return response.data
        },
        async updateAssignees( { dispatch }, data) {
            let response = await axios.post('crm/job/update_assignees', data)
            await dispatch('getData')
            return response.data
        },
        async addJobComment(_, data) {
            let response = await axios.post('crm/job/comment', data)        
            return response.data
        },
        async addWorkorder( { dispatch }, data) {
            let response = await axios.post('crm/wo/add', data)
            await dispatch('getData')
            return response.data
        },
        async updateWorkorder( { dispatch }, data) {
            let response = await axios.post('crm/wo/update', data)
            await dispatch('getData')
            return response.data
        },
    }
}